import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'square', 'Square', [["path",{"d":"M3 5a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-14","key":"svg-0"}]]);